import { 
    GET_QUESTION_RESULTS, GET_QUESTION_RESULTS_FAILED, 
    GET_SKIP_QUESTION, GET_SKIP_QUESTION_FAILED, 
    GET_QUESTION_COUNT, GET_QUESTION_COUNT_FAILED, 
    FETCH_AVAILABLE_QUESTIONS, FETCH_AVAILABLE_QUESTIONS_FAILED, 
    GET_QUESTION, GET_QUESTION_FAILED, 
    PUT_RESPONSE, PUT_RESPONSE_FAILED,
    COMPLETE_SASP_TEST, COMPLETE_SASP_TEST_FAIL,
    GET_FLASH_CARD, GET_FLASH_CARD_FAILED
} from "../actions";

const INITIAL_STATE = {
    question: [],
    sessionAnsweredQuestion: [],
    error: "",
    available_questions: [],
    get_question_count: [],
    get_question_results: {},
    deck_results: [],
    flashCard: {}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case PUT_RESPONSE:
            return { ...state, sessionAnsweredQuestion: action.payload, error: '' };
        case GET_QUESTION:
            return { ...state, question: action.payload, error: '' };
        case GET_QUESTION_RESULTS:
            return { ...state, get_question_results: action.payload, error: '' };
        case GET_SKIP_QUESTION:
            return { ...state, question: action.payload, error: '' };
        case FETCH_AVAILABLE_QUESTIONS:
            return {...state, available_questions: action.payload, error: '' }
        case GET_QUESTION_COUNT:
            return {...state, get_question_count: action.payload, error: '' }
        case GET_FLASH_CARD:
            return {...state, flashCard: action.payload, error: '' }

        case GET_FLASH_CARD_FAILED:
        case GET_QUESTION_COUNT_FAILED:
        case COMPLETE_SASP_TEST_FAIL:
        case PUT_RESPONSE_FAILED:
        case GET_QUESTION_RESULTS_FAILED:
        case GET_SKIP_QUESTION_FAILED:
        case GET_QUESTION_FAILED:
        case FETCH_AVAILABLE_QUESTIONS_FAILED:
            return {...state, error: action.payload}
        default:
            return state;
    }
};
